import { z } from 'zod';
import type { LocaleType } from '@/models/common/locale.ts';
import type { Lead, LeadId, LocalizableTemporal } from '@/models/entities/lead';

export const SearchQueryBrand = z.preprocess((val) => {
  if (val == null) return '';
  return val;
}, z.string().trim().brand<'SearchQuery'>());
export const SearchQueryNone = SearchQueryBrand.parse('');
export type SearchQuery = z.infer<typeof SearchQueryBrand>;

export interface LeadSearchModel {
  leadId: LeadId;
  customerName: string;
  contactName: string;
  phoneNumber: string;
  vin: string;
  dealerName: string;
  status: string;
  // All fields from maintenance items
  maintenanceItems: string;
  // Formatted dates
  createdAt: string;
  scheduledDate: string;
  dueDate: string;
}

export function mapLeadToSearchModel(
  lead: Lead,
  locale: LocaleType,
): LeadSearchModel {
  const formatDate = (date: LocalizableTemporal) => {
    return date.toLocaleString(locale);
  };

  const maintenanceItems = lead.maintenance.maintenanceItems
    .map(
      (item) =>
        `${item.description} ${item.parts.map((p) => p.display).join(' ')}`,
    )
    .join(' ');

  return {
    leadId: lead.id,
    customerName: lead.customer.name,
    contactName: lead.customer.contactName || '',
    phoneNumber: lead.customer.contactPhone || '',
    vin: lead.vin,
    dealerName: lead.homeDealer?.name || '',
    status: lead.workflow.status,
    maintenanceItems,
    createdAt: formatDate(lead.workflow.createdAt),
    scheduledDate: lead.workflow.scheduledDate
      ? formatDate(lead.workflow.scheduledDate)
      : '',
    dueDate: formatDate(lead.maintenance.dueDate),
  };
}
